module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": "",
      "prevent-back": ""
    },
    on: {
      "back": _vm.onBack
    }
  }, [_vm._v("绑定邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('form', {
    staticClass: "flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.bind($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "请输入要绑定的邮箱",
      "autofocus": "",
      "readonly": !_vm.rebind && _vm.user.emailVerified
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [(_vm.validation.hasError('email')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('email')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    directives: [{
      name: "longpress",
      rawName: "v-longpress",
      value: (function () { return _vm.rebind = true; }),
      expression: "()=>rebind=true"
    }],
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(!_vm.rebind && _vm.user.emailVerified ? '邮箱已绑定，长按开始重新绑定' : (_vm.sent ? '我已完成绑定' : '绑定邮箱')) + "\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c677524","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BindEmail.vue
// module id = 236
// module chunks = 12